export default __webpack_public_path__ + "static/media/Bracers of the Inconceivable.36425be7.jpg";